// src/store.js
import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './root-reducer';

// configureStore provides a better, simpler API
const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: {
        ignoredPaths: [
          'form.parameters',
          'mcqform.parameters',
          'mcqform.contentArr',
          'flipform.parameters',
          'form.dndArray',
          'form.dndParameters',
        ],
      },
    }),
});

export default store;
